/* eslint-disable react/prop-types */
import React from 'react';
import { Icon } from 'mkui-fd';
import PropTypes from 'prop-types';

var Topbar = function Topbar(props) {
  var onZoom = props.onZoom,
      onRotate = props.onRotate,
      onDownload = props.onDownload,
      toolBarExtraContent = props.toolBarExtraContent,
      prefixCls = props.prefixCls;
  return React.createElement("div", {
    className: prefixCls
  }, React.createElement(Icon, {
    type: "zoom-in",
    className: "".concat(prefixCls, "-icon"),
    onClick: function onClick() {
      onZoom('zoomin');
    }
  }), React.createElement(Icon, {
    type: "zoom-out",
    className: "".concat(prefixCls, "-icon"),
    onClick: function onClick() {
      onZoom('zoomout');
    }
  }), React.createElement(Icon, {
    type: "rotate-right",
    className: "".concat(prefixCls, "-icon"),
    onClick: function onClick() {
      onRotate('clockwise');
    }
  }), React.createElement(Icon, {
    type: "rotate-left",
    className: "".concat(prefixCls, "-icon"),
    onClick: function onClick() {
      onRotate('anticlockwise');
    }
  }), React.createElement(Icon, {
    type: "download",
    className: "".concat(prefixCls, "-icon"),
    onClick: onDownload
  }), toolBarExtraContent);
};

Topbar.propTypes = {
  onZoom: PropTypes.func,
  onRotate: PropTypes.func,
  onDownload: PropTypes.func,
  prefixCls: PropTypes.string
};
Topbar.defaultProps = {
  onZoom: function onZoom() {},
  onRotate: function onRotate() {},
  onDownload: function onDownload() {},
  prefixCls: 'mkui-image-viewer-option'
};
;
export default Topbar;
//# sourceMappingURL=Topbar.js.map
